"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Search = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _translations = require("../../helpers/translations");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

require("./Search.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles() {
  return {
    clearIcon: {
      fontSize: '28px',
      transition: 'color 300ms'
    },
    clearIconHide: {
      opacity: 0,
      transition: 'opacity 500ms',
      visibility: 'hidden',
      fontSize: '28px'
    },
    searchIcon: {
      fontSize: '28px'
    },
    searchIconHide: {
      color: 'rgb(175, 175, 175)',
      fontSize: '28px'
    }
  };
};

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: _this.props.open
    });

    _defineProperty(_assertThisInitialized(_this), "uniqueSearchInputId", "Search_input_".concat((0, _uuid.v4)()));

    _defineProperty(_assertThisInitialized(_this), "onSearchTermChange", function (value) {
      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleInput", function () {
      _this.setState({
        open: !_this.state.open
      }, function () {
        if (_this.state.open) {
          document.getElementById(_this.uniqueSearchInputId).focus();
        } else {
          _this.onSearchTermChange('');
        }
      });
    });

    return _this;
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // opens Search textfield if a value is provided and it is currently closed; this is done in the SmartTable
      !this.state.open && !prevProps.value && this.props.value && this.setState({
        open: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          direction = _this$props.direction,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled;
      var open = this.state.open;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "Search_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "Search_inputElements ".concat(direction)
      }, value.length > 0 ? /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: "Clear",
        id: "Search_clearIcon"
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.onSearchTermChange('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
        className: classes.clearIcon
      }, "clear"))) : /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: "",
        id: "Search_clearIcon"
      }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
        className: classes.clearIconHide
      }, "clear"))), /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        id: "Search_searchIcon",
        buttonProps: {
          color: 'primary',
          disabled: disabled
        },
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.toggleInput(e);
        },
        icon: "search",
        title: "Search"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        id: this.uniqueSearchInputId,
        className: "Search_input ".concat(open ? 'open' : '', " ").concat(direction),
        placeholder: placeholder ? placeholder : (0, _translations.getTranslations)('search_enter_term_text'),
        value: value,
        onChange: function onChange(e) {
          e.stopPropagation();

          _this2.onSearchTermChange(e.target.value);
        },
        onFocus: function onFocus(e) {
          e.stopPropagation();

          _this2.props.onSearchFocus(e);
        },
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.props.onSearchClick(e);
        }
      })), /*#__PURE__*/_react["default"].createElement("hr", {
        id: "Search_underline",
        className: "".concat(open ? 'open' : '', " ").concat(direction)
      }));
    }
  }]);

  return Search;
}(_react["default"].Component);

exports.Search = Search;

_defineProperty(Search, "propTypes", {
  classes: _propTypes["default"].object.isRequired,
  direction: _propTypes["default"].oneOf(['right', 'left']),
  onChange: _propTypes["default"].func.isRequired,
  onSearchFocus: _propTypes["default"].func,
  onSearchClick: _propTypes["default"].func,
  value: _propTypes["default"].string.isRequired,
  open: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string
});

_defineProperty(Search, "defaultProps", {
  direction: 'left',
  value: '',
  open: false,
  placeholder: '',
  onSearchFocus: function onSearchFocus() {
    return null;
  },
  onSearchClick: function onSearchClick() {
    return null;
  }
});

var _default = (0, _styles.withStyles)(styles)(Search);

exports["default"] = _default;